/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/4/21
 * Copyright All Rights Reserved
 */
// @flow
import React from 'react';
import { Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

const Page3 = () => (
  <Row className="reset-password-form reset-password-form-success-page">
    <Col lg="8">
      <p>
        <strong>Success!</strong> Your password has been updated. You can now use your new password
        to <Link to="/sign-in">sign in</Link> to your account.
      </p>
    </Col>
  </Row>
);


export default Page3;



// WEBPACK FOOTER //
// ./js/components/pages/ResetPassword/ResetPasswordForm/ResetPasswordFormSuccessPage/index.jsx